module.exports = __webpack_public_path__ + "img/services-activity-photo-1.754b78d0.png";